module.exports = __webpack_public_path__ + "static/media/upload_file_black_24dp.0be367d9.svg";